import { render, staticRenderFns } from "./sacramentAttendance.vue?vue&type=template&id=0fb5a2c4&"
import script from "./sacramentAttendance.vue?vue&type=script&setup=true&lang=js&"
export * from "./sacramentAttendance.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./sacramentAttendance.vue?vue&type=style&index=0&id=0fb5a2c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports